import { AdministrationMessageItem } from '../types-store';

export const hasChanges = (message: AdministrationMessageItem, original: AdministrationMessageItem): boolean => {

  if ((message && message.id) !== (original && original.id)) {
    return true;
  }

  if ((message && message.active) !== (original && original.active)) {
    return true;
  }

  const translations = ((message ?? {}).translations ?? [])
    .filter(languageItem => (languageItem.subject ?? '').trim().length > 0
      || (languageItem.message ?? '').trim().length > 0);
  const originalTranslations = ((original ?? {}).translations ?? [])
    .filter(languageItem => (languageItem.subject ?? '').trim().length > 0
      || (languageItem.message ?? '').trim().length > 0);

  if (translations.length !== originalTranslations.length) {
    return true;
  }

  if (translations.some(
    translation => !originalTranslations.some(
      originalTranslation => translation.language === originalTranslation.language &&
        (translation.subject ?? '') === (originalTranslation.subject ?? '') &&
        (translation.message ?? '') === (originalTranslation.message ?? ''))
  )) {
    return true;
  }

  return false;
};
